document.addEventListener("DOMContentLoaded", function () {
  // Select each group of accordions
  const accordionGroups = document.querySelectorAll(".fum-accordion-group-1");

  accordionGroups.forEach(function (group) {
    const accItems = group.getElementsByClassName("fum-faq-accordion");

    // Open the first accordion item by default in each group
    if (accItems.length > 0) {
      accItems[0].classList.add("active");
      const firstPanel = accItems[0].nextElementSibling;
      if (firstPanel) {
        firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
      }
    }

    // Event listeners for accordion items within this group
    for (let i = 0; i < accItems.length; i++) {
      accItems[i].addEventListener("click", function () {
        // Collapse all accordion items within this group
        for (let j = 0; j < accItems.length; j++) {
          if (
            accItems[j] !== this &&
            accItems[j].classList.contains("active")
          ) {
            accItems[j].classList.remove("active");
            const panel = accItems[j].nextElementSibling;
            if (panel) {
              panel.style.maxHeight = null;
            }
          }
        }

        // Toggle the clicked accordion item
        this.classList.toggle("active");
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  });
});